export default __webpack_public_path__ + "static/media/new-unpublish-icon.f7bc0972.svg";